export const rowsPerPageOptions = [10, 25, 50, 100];
export const rowsPerPageDefault = rowsPerPageOptions[1];
